import * as types from "./types";
import Routes from "../../api/routes"; // API endpoint routes
import { get, post, file } from "../../api";
import { set_cookie } from "utils";
import { klaviyoSubscribe } from "./contactus";
const {
  GET_RESERVATION_DETAILS,
  APPLY_PROMOCODE,
  REMOVE_PROMOCODE,
  BOOKING_SAVE,
  BOOKING_REQUEST,
  BOOKING_ORDER,
  BOOKING_TOKEN_GENRATE,
  STABLECOIN_PAYMENT_INTENT_TOKEN_GENERATE,
  STABLECOIN_CHECK_AVAILABILITY,
  STABLECOIN_PLACE_ORDER,
  CRYPTO_CHECKOUT_CONFIRM,
  CRYPTO_CHECKOUT_CANCEL,
  DISTANCE_METRIX,
} = Routes;

/*******************
@purpose :  get vehilce booking details
@Parameter : {booking_id}
@Author : INIC
******************/
export const getReservationDetails =
  (id, loader = true) =>
    (dispatch) => {
      return get(
        GET_RESERVATION_DETAILS.replace("bookingId", id),
        true,
        loader
      ).then((res) => {
        if (res?.statusCode == 200) {
          dispatch(setBookinDetails(res.data));
          return Promise.resolve(res.data);
        }
        return Promise.reject(res);
      });
    };

/********************
@purpose : Used for store logout responce and remove token in cookie
@Parameter : { }
@Author : INIC
******************/
export const setBookinDetails = (data) => ({
  type: types.SET_RESERVATION_DETAILS,
  data,
});

/*******************
@purpose :  apply promocode
@Parameter : {data}
@Author : INIC
******************/
export const applyPromocode = (data) => (dispatch) => {
  return post(APPLY_PROMOCODE, true, data).then((res) => {
    if (res?.statusCode == 200) {
      dispatch(getReservationDetails(data.vehicle_booking_id));
      return Promise.resolve(res.data);
    }
    return Promise.reject(res);
  });
};

/*******************
@purpose :  remove promocode
@Parameter : {data}
@Author : INIC
******************/
export const removePromocode = (data) => (dispatch) => {
  return post(REMOVE_PROMOCODE, true, data).then((res) => {
    if (res?.statusCode == 200) {
      dispatch(getReservationDetails(data.vehicle_booking_id));
      return Promise.resolve(res.data);
    }
    return Promise.reject(res);
  });
};

/********************
@purpose : Used for store logout responce and remove token in cookie
@Parameter : { }
@Author : INIC
******************/
export const setDistanceMilesDetails = (data) => ({
  type: types.SET_DISTANCE_MILES_DETAILS,
  data,
});

/*******************
@purpose :  google distance matrix
@Parameter : {data}
@Author : INIC
******************/
export const googleDistanceMatrixData = (data) => (dispatch) => {
  return post(DISTANCE_METRIX, true, data).then((res) => {
    if (res?.statusCode == 200) {
      dispatch(setDistanceMilesDetails(res?.data));
      return Promise.resolve(res.data);
    }
    return Promise.reject(res);
  });
};

/*******************
@purpose :  save booking
@Parameter : {data}
@Author : INIC
******************/
export const bookingSave = (data, isLoader = true) => () => {
  return post(BOOKING_SAVE, true, data, false, isLoader)
    .then((res) => {
      if (res?.success) {
        return res.data; // Only return data if success is true.
      }
      return Promise.reject(res); // Reject the promise if success is false.
    })
    .catch((err) => {
      return Promise.reject(err); // Pass the error back to the caller.
    });
};

/*******************
@purpose :  request booking
@Parameter : {data}
@Author : INIC
******************/
export const bookingRequest = (data) => () => {
  return post(BOOKING_REQUEST, true, data, false, false).then((res) => {
    if (res) {
      return res.data;
    }
    return Promise.reject(res);
  });
};

/*******************
@purpose : place order
@Parameter : {data}
@Author : INIC
******************/
export const placeBookingOrder =
  (data, loader = true) =>
    (dispatch) => {
      return file(BOOKING_ORDER, true, data, loader).then((res) => {
        if (res?.statusCode == 200) {
          set_cookie("phoneNoOrderTime", res?.data?.phone?.trim(), 2);
          set_cookie("isoCode", res?.data?.country_shortname?.toLowerCase(), 2);
          set_cookie("total", res?.data?.total, 1);
          set_cookie("decId", res?.data?.dec_id, 1);
          set_cookie("selectedCar", res?.data?.vehicle?.name_with_brand, 1);

          const klaviyoData = {
            subscriber_email: res?.data?.email,
            location_id: res?.data?.location_id,
          };
          dispatch(klaviyoSubscribe(klaviyoData));
          return res.data;
        }
        return Promise.reject(res);
      });
    };

/*******************
@purpose : place order
@Parameter : {data}
@Author : INIC
******************/
export const generateBookingToken =
  (id, data, loader = true) =>
    () => {
      return file(
        BOOKING_TOKEN_GENRATE.replace("bookingId", id),
        true,
        data,
        loader
      ).then((res) => {
        if (res?.statusCode == 200) {
          return res.data;
        }
        return Promise.reject(res);
      });
    };

/********************
@purpose : Used to set payment form validation state
@Parameter : { }
@Author : INIC
******************/
export const setPaymentFormValidation = (data) => ({
  type: types.SET_IS_FORM_VALID,
  data,
});


// ---------------------------------------------------------------------------
// Stablecoin payment actions
// ---------------------------------------------------------------------------

/**
 * Create a Stripe PaymentIntent configured for stablecoin (PaymentElement).
 * Returns { client_secret } from the backend.
 */
// createStablecoinPaymentIntent
    // generateStablecoinPaymentIntentToken
export const generateStablecoinPaymentIntentToken =
    (bookingId, isSplit = 0) =>
        () => {
          const url = STABLECOIN_PAYMENT_INTENT_TOKEN_GENERATE.replace("bookingId", bookingId);
          return post(url, true, { is_split: isSplit }, false).then((res) => {
            if (res?.statusCode === 200) {
              return res.data; // { client_secret }
            }
            return Promise.reject(res);
          });
        };

export const confirmStablecoinOrder =
    (vehicleBookingId, locationId, isSplit, paymentIntentId, redirectStatus) =>
        () => {
            const url = `${STABLECOIN_PLACE_ORDER}?vehicle_booking_id=${encodeURIComponent(vehicleBookingId)}&location_id=${encodeURIComponent(locationId ?? "")}&is_split=${encodeURIComponent(isSplit ?? 0)}&payment_intent=${encodeURIComponent(paymentIntentId)}&redirect_status=${encodeURIComponent(redirectStatus)}`;
            return post(url, false, false).then((res) => {
                if (res?.statusCode === 200) {
                    set_cookie("phoneNoOrderTime", res?.data?.phone?.trim(), 2);
                    set_cookie("isoCode", res?.data?.country_shortname?.toLowerCase(), 2);
                    set_cookie("total", res?.data?.total, 1);
                    set_cookie("decId", res?.data?.dec_id, 1);
                    set_cookie("selectedCar", res?.data?.vehicle?.name_with_brand, 1);
                    return res.data;
                }
                return Promise.reject(res);
            });
        };

export const checkVehicleAvailability =
    (bookingId) =>
        () => {
            const url = STABLECOIN_CHECK_AVAILABILITY.replace("bookingId", bookingId);
            return post(url, true, {}, false).then((res) => {
                if (res?.statusCode === 200) {
                    return res.data; // { isAvailable, message }
                }
                return Promise.reject(res);
            });
        };

/**
 * Finalise the booking after a successful stablecoin payment confirmation.
 */
export const placeStablecoinBookingOrder =
    (data, loader = true) =>
        (dispatch) => {
          return file(STABLECOIN_PLACE_ORDER, true, data, loader).then((res) => {
            if (res?.statusCode === 200) {
              set_cookie("phoneNoOrderTime", res?.data?.phone?.trim(), 2);
              set_cookie("isoCode", res?.data?.country_shortname?.toLowerCase(), 2);
              set_cookie("total", res?.data?.total, 1);
              set_cookie("decId", res?.data?.dec_id, 1);
              set_cookie("selectedCar", res?.data?.vehicle?.name_with_brand, 1);
              return res.data;
            }
            return Promise.reject(res);
          });
        };

export const confirmCryptoCheckoutOrder = (sessionId) => () => {
    return post(CRYPTO_CHECKOUT_CONFIRM, false, { session_id: sessionId }).then((res) => {
        if (res?.statusCode === 200) return res.data;
        return Promise.reject(res);
    });
};

export const cancelCryptoCheckoutOrder = (sessionId) => () => {
    return post(CRYPTO_CHECKOUT_CANCEL, false, { session_id: sessionId }).then((res) => {
        if (res?.statusCode === 200) return res.data;
        return Promise.reject(res);
    });
};
